import React from "react";
import TSTable from "../common/TSTable";
import { Button, Col, Layout, Popconfirm, Row, Tag, theme, Tooltip, Typography } from 'antd';
import HeaderScreen from "../common/HeaderScreen";
import * as _ from "lodash";
import { Content } from "antd/es/layout/layout";
import {
  PlusOutlined,
  PrinterOutlined,
  DeleteOutlined,
  VerticalAlignBottomOutlined,
  EyeOutlined
} from '@ant-design/icons';
import { BLUE_COLOR, LAB_COLOR, PRINT_COLOR, SECONDARY_COLOR, WHITE_COLOR } from "../constants/color";
import { URL_LAB, URL_POND, URL_TANK, URL_CHEMICAL, URL_REPORT } from "../constants/urls";
import { useParams } from "react-router-dom";
import { DELETE, GET } from "../frameworks/HttpClient";
import ColorButton from "../common/ColorButton";
import PondTankLabWeightModal from "../components/pond-latex/PondTankLabWeightModal";
import { dateTimeToHumanString, formatComma, toFixed } from "../frameworks/Util";
import { CHEMICAL } from "../constants/chemical";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LabResultsModal from "../components/lab-latex/LabResultsModal";
import { faFlask, faTruck } from "@fortawesome/free-solid-svg-icons";
import { LAB_ORDER_TYPE, POND_STATUS } from "../constants/string";
import LabAddChemicalModal from "../components/lab-latex/LabAddChemicalModal";
import PondTruckLogModal from "../components/pond-latex/PondTruckLogModal";
import CustomDeleteConfirmButton from "../common/CustomDeleteConfirmButton";
import ErrorMessages from "../common/ErrorMessages";
import ReportButton from "../components/common/ReportButton";
import LabAddChemicalHistoryModal from "../components/lab-latex/LabAddChemicalHistoryModal";

export default function PondTankLabScreen() {
  const params = useParams();
  const { Paragraph } = Typography;
  const { token : { colorSuccess, colorPrimary, colorWarning }} = theme.useToken();
  const [ pondData, setPondData ] = React.useState(null);
  const [ tankData, setTankData ] = React.useState(null);
  const [ state, setState] = React.useState(null);
  const [ errorMessages, setErrorMessages ] = React.useState(null);
  const [ target, setTarget ] = React.useState(null);
  const [ fillTarget, setFillTarget ] = React.useState(null);
  const [ transaction, setTransaction ] = React.useState(null);
  const [ fillChemical, setFillChemical ] = React.useState(null);
  const [ truckLogTarget, setTruckLogTarget ] = React.useState(null);
  const [ historyTarget, setHistoryTarget ] = React.useState(null);
  const tableRef = React.useRef();
  
  const columnChemicalWidth = 60;

  const fetchPondData = async() => {
    setErrorMessages(null);
    try {
      const response = await GET(`${URL_POND.POND_TRANSACTION}${params.id}/`)
      setPondData(response.data)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const fetchTankData = async() => {
    setErrorMessages(null);
    try {
      const response = await GET(`${URL_TANK.TANK_TRANSACTION}${params.id}/`)
      setTankData(response.data)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const { token : {colorError}} = theme.useToken();

  const refreshData =() => {
    if(tableRef.current){
      tableRef.current.fetchWithoutResetPage();
    }
  }

  const handleDelete = async(id) => {
    setErrorMessages(null);
    try {
      await DELETE(`${URL_LAB.LAB_ORDER}${id}/`)
      refreshData();
    } catch (error) {
      setErrorMessages(error.setErrorMessage)
    }
  }

  const fetchChemical = async() => {
    setErrorMessages(null);
    try {
      const response = await GET(URL_CHEMICAL.QUALITY_CHEMICAL, {ordering : 'name'})
      setFillChemical(response.data.results);
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const columns = [
    {
      title: <center>Actions</center>,
      width: 150,
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      render : (value, original) => {
        return (<center>
          {(params.role === LAB_ORDER_TYPE.POND || params.role === LAB_ORDER_TYPE.LAB_POND) && 
            <ReportButton url={`${URL_REPORT.LAB_REQUEST_ORDER}${value}/`} tooltip={'พิมพ์สติ๊กเกอร์แปะตัวอย่าง'} sentError={(e) => setErrorMessages(e)}/>
          }

          {/* {!original.lab_user && 
            <CustomDeleteConfirmButton
              onOk={ async() => {
                await handleDelete(original.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
          } */}
          {original.lab_user && !_.get(original, 'inputs', []).find((e) => e.input_amount) && (params.role === LAB_ORDER_TYPE.LAB_POND || params.role === LAB_ORDER_TYPE.LAB_TANK) && 
          <Tooltip triger='hover' title={"แก้ไขผลแล็บ"}>
            <ColorButton 
              type='primary'
              override={colorWarning}
              style={{ margin : 5}}
              icon={<FontAwesomeIcon icon={faFlask}/>}
              onClick={()=> setTarget(original)}
            />
          </Tooltip>}

          {!original.lab_user && (params.role === LAB_ORDER_TYPE.LAB_POND || params.role === LAB_ORDER_TYPE.LAB_TANK) && 
          <Tooltip triger='hover' title={"ส่งผลแล็บ"}>
            <ColorButton 
              type='primary'
              override={LAB_COLOR}
              style={{ margin : 5}}
              icon={<FontAwesomeIcon icon={faFlask}/>}
              onClick={()=> setTarget(original)}
            />
          </Tooltip>}

          {_.get(original, 'inputs', []).length > 0 && (params.role === LAB_ORDER_TYPE.POND || params.role === LAB_ORDER_TYPE.TANK) &&
          <Tooltip triger='hover' title={"เติมสารเคมี"}>
            <ColorButton 
              type='primary'
              override={colorSuccess}
              style={{ margin : 5}}
              icon={<VerticalAlignBottomOutlined />}
              onClick={()=> setFillTarget(original)} 
            />
          </Tooltip>
          }

          {original.lab_user && original.is_input_progressing === false && 
          _.size(original.inputs.filter((e) => !e.input_amount)) == 0 &&  
          (params.role === LAB_ORDER_TYPE.POND || params.role === LAB_ORDER_TYPE.TANK) &&
            <Tooltip triger='hover' title={"ประวัติเติมสารเคมี"}>
              <ColorButton 
                type='primary'
                override={colorPrimary}
                style={{ margin : 5}}
                icon={<EyeOutlined />}
                onClick={()=> setHistoryTarget(original)} 
              />
            </Tooltip>
          }
        </center>)
      }
    },
    {
      title: <center>Example No.</center>,
      width: 130,
      dataIndex: 'code',
      key: 'code',
      fixed: 'left',
      searcher : true,
    },
    {
      title: <center>ลำดับ</center>,
      width: 50,
      dataIndex: 'index',
      key: 'index',
      fixed: 'left',
      render: (value) => <center>{value}</center>
    },
    {
      title: <center>น้ำหนัก</center>,
      width: 120,
      dataIndex: 'ref_detail',
      key: '',
      fixed: 'left',
      render : (value, original) => 
        <center>
          <div>{formatComma(toFixed(_.get(original, 'original_weight', '-'),0))} Kg </div>
          <div>{_.get(original, 'original_height', '-')} cm </div>
        </center>
    },
    {
      title: <center>ตักตัวอย่าง</center>,
      width: 160,
      dataIndex: '',
      key: '',
      fixed: 'left',
      render : (value, original) => 
      <center>
        <div>{dateTimeToHumanString(_.get(original, 'created', '-'))} </div>
        <div>{`(${_.get(original, 'created_by_name', '-')})`}</div>
      </center>
    },
    {
      title: <center>ผู้ลงผลแล็บ</center>,
      width: 160,
      dataIndex: 'lab_user_name',
      key: 'lab_user_name',
      fixed: 'left',
      render : (value, original) => 
        <center>
          <div>{dateTimeToHumanString(_.get(original, 'lab_datetime', '-'))} </div>
          {value && <div>{`(${_.get(original, 'lab_user_name', '-')})`}</div>}
        </center>
    },
    {
      title: <center>ผลแล็บ</center>,
      dataIndex: 'result',
      key: 'result',
      //  Column ผลแล็บ 
      children: _.get(CHEMICAL,(pondData ? 'POND' : 'TANK'), []).map(
        (data) => {
          return {
            title : <center>{data.chemical}</center> ,
            dataIndex: data.chemical,
            width: columnChemicalWidth,
            key: data.chemical,
            render : (value, original) => {
              const findData = (_.find(_.get(original, 'results' , []), { 'chemical': _.get(data, 'chemical' , '')} ))
              if(findData){
                return <center>{formatComma(_.get(findData, 'amount' , '-'))}</center>
              } else return <center> - </center>
            }
          }
        }
      )
    },
    {
      title: <center>สารเคมีที่ต้องเติม</center>,
      dataIndex: 'age',
      key: 'age',
      children: [..._.filter(fillChemical,(pondData ? {pond : true} : {tank : true}), []).map((data) => {
        return {
          title : <center>{data.name}</center> ,
          dataIndex: data.name,
          width: columnChemicalWidth,
          key: data.id,
          render : (value, original) => {
            const findData = (_.find(_.get(original, 'inputs' , []), { 'chemical': _.get(data, 'name' , '')} ))
            if(findData){
              return <center>{formatComma(_.get(findData, 'amount' , '-'))}</center>
            } else return <center> - </center>
          }
        }
      }
      ),   
      {
        title: <center>อื่นๆ</center>,
        dataIndex: 'other',
        width: 150,
        key: 'other',
        render : (value, original) => {
          const otherChemical = _.filter(fillChemical, {tank : false, pond : false})
          const output = _.filter(original.inputs, (item) => {
            return _.some(otherChemical, { name: item.chemical });
          });

          return output.map((render) => {
            return <div>{render.chemical} : {formatComma(render.amount)}</div>
          }) 
        }
      }]
    }
  ]

  React.useEffect(() => {
    fetchChemical();
    if(params.role === LAB_ORDER_TYPE.POND || params.role === LAB_ORDER_TYPE.LAB_POND ){
      fetchPondData();
    } else if (params.role === LAB_ORDER_TYPE.TANK || params.role === LAB_ORDER_TYPE.LAB_TANK ){
      fetchTankData();
    } 
  },[])

  React.useEffect(() => {
    refreshData();
    setErrorMessages(null)
    if(pondData){
      setState(pondData.state)
    }

    if(tankData){
      setState(tankData.state)
    }
  },[pondData || tankData])

	return(
    <Layout>
      <HeaderScreen title={pondData ? `แล็บบ่อพัก - ${_.get(pondData, 'pond_name', '-')} [${_.get(pondData, 'lot_no', '-')}]` : `แล็บแทงก์ - ${_.get(tankData, 'tank_name', '-')} [${_.get(tankData, 'lot_no', '-')}]`} 
        style={{ backgroundColor : SECONDARY_COLOR, color : WHITE_COLOR, fontSize : 18, fontWeight: 'bolder' }}  />
      <Content
        style={{
          margin: 24,
          minHeight: 280,
          padding: "0px 24px",
      }}>
        <ErrorMessages message={errorMessages}/>
        <Row style={{width : '100%', marginTop : 16}}>
          <Col style={{ marginTop : 14}} span={5}>
            {pondData && <Row>
              <Paragraph style={{ marginRight: 10, padding: 0,}}>น้ำหนักสะพานชั่ง :</Paragraph>
              <Tag style={{ height: 26 }} color={BLUE_COLOR}>{formatComma(toFixed(_.get(pondData, 'truck_transactions_weight', '-'),0))}</Tag>
            </Row>}
          </Col>
          <Col style={{ marginTop : 14}} span={5}>
            {pondData && <Row>
              <Paragraph style={{ marginRight: 10, padding: 0}}>น้ำหนักวัดเทียบ :</Paragraph>
              <Tag style={{ height: 26 }} color={BLUE_COLOR}>{pondData && pondData.close_weight ? formatComma(toFixed(pondData.close_weight, 0)) : '-' }</Tag>
            </Row>}
          </Col>
          <Col style={{ marginTop : 14}} span={5}>
            {pondData && <Row>
              <Paragraph style={{ marginRight: 10, padding: 0}}>น้ำหนัก TZ รวม :</Paragraph>
              <Tag style={{ height: 26 }} color={BLUE_COLOR}>{formatComma(toFixed(_.get(pondData, 'truck_transactions_tz_weight', '-')), 2)}</Tag>
            </Row>}
          </Col>
          <Col style={{ marginTop : 14}} span={9}> 
            {state !== POND_STATUS.END &&<ColorButton 
              type='primary'
              override={colorSuccess}
              style={{ float : 'right', marginBottom : 20 }}
              icon={<PlusOutlined />}
              onClick={()=>{
                if(params.role === LAB_ORDER_TYPE.LAB_TANK){
                  setTarget({'type' : LAB_ORDER_TYPE.TANK, 'weight_per_height' : tankData.weight_per_height, lot_no : tankData.lot_no, 'current_height' : tankData.current_height, 'current_weight' : tankData.current_weight})
                } else if (params.role === LAB_ORDER_TYPE.LAB_POND) {
                  setTarget({'type' : LAB_ORDER_TYPE.POND, 'weight_per_height' : pondData.weight_per_height, lot_no : pondData.lot_no, 'current_height' : pondData.current_height, 'current_weight' : pondData.current_weight})
                } else {
                  if(pondData){
                    setTransaction(pondData)
                  } else {
                    setTransaction(tankData)
                  }
                }
              }}
            >
              เพิ่มตัวอย่าง
            </ColorButton>}
            {state !== POND_STATUS.END && pondData && <Button 
              // type='primary'
              // override={colorSuccess}
              variant="outlined"
              style={{ float : 'right', marginBottom : 20, marginRight: 10, color : PRINT_COLOR, borderColor: PRINT_COLOR }}
              icon={<FontAwesomeIcon icon={faTruck}/>}
              onClick={()=> setTruckLogTarget(pondData ? pondData : tankData)}
            >
              รถเทลงบ่อ
            </Button>}
          </Col>
        </Row>
        <TSTable
          ref={tableRef}
          pagination={false}
          size={"small"}
          columns={columns}
          url={pondData || tankData ? URL_LAB.LAB_ORDER : null}
          params={{ ref : pondData ? _.get(pondData, 'id', '') : _.get(tankData, 'id', ''), type : pondData ? 'pond' : 'tank' }}
          scroll={{
            x: 'max-content',
          }}
          rowClassName={(record) => {
            if (record.is_input_progressing) {
              return "table-row-red";
            }
          }}
        />
      </Content>

      <PondTankLabWeightModal
        open={transaction ? true : false}
        onClose={() => {
          setTransaction(null)
        }}
        onUpdate={() => {
          setTransaction(null);
          refreshData();
        }}
        target={transaction}
        role={pondData ? LAB_ORDER_TYPE.POND : LAB_ORDER_TYPE.TANK}
      />

      <LabResultsModal
        open={target ? true : false}
        onClose={() => {
          setTarget(null)
        }}
        target={target}
        onUpdate={() => {
          setTarget(null)
          refreshData();
        }}
      />

      <PondTruckLogModal
        open={truckLogTarget ? true : false}
        onClose={() => setTruckLogTarget(null)}
        target={truckLogTarget}
        onUpdate={() => {
          setTruckLogTarget(null)
          refreshData();
        }}
        hideActions
      />

      <LabAddChemicalModal
        open={fillTarget ? true : false}
        onClose={() => setFillTarget(false)}
        onUpdate={() => {
          setFillTarget(false);
          refreshData();
        }}
        target={fillTarget}
      />

      <LabAddChemicalHistoryModal
        open={historyTarget ? true : false}
        onClose={() => setHistoryTarget(false)}
        onUpdate={() => {
          setHistoryTarget(false);
          refreshData();
        }}
        target={historyTarget}
      />

    </Layout>
)
}